export default __webpack_public_path__ + "static/Sjef_Van_den_Buys_3-15376b3d83c7fa3d4381605e5d4b8d18.jpg";